export default __webpack_public_path__ + "static/media/avatar_nikki_dog2.b9acba52.mp3";